import React, {Component} from 'react';
import autobind from 'autobind-decorator';

export class ChildrenList extends Component {
    @autobind
    getChildren() {
        const { Children, Sort } = this.props;

        if(Children) {
            if(Sort) {
                return Children.sort(Sort);
            } else {
                return Children;
            }
        }

        return [];
    }

    @autobind
    getChildrenCount() {
        const { Children } = this.props;

        if(Children) {
            return Children.length;
        }

        return 0;
    }

    render() {
        const { Hidden, Title, Render } = this.props;

        if(Hidden) {
            return null;
        }
        
        if(this.getChildrenCount() === 0) {
            return (
                <div className="sb-children-list">
                    <h2 className="sb-children-list-title">
                        {Title || ""}
                    </h2>

                    <div className="sb-children-list-data">
                        <div className="sb-children-list-node">
                           No {Title}
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div className="sb-children-list">
                <h2 className="sb-children-list-title">
                    {Title || ""}
                </h2>

                <div className="sb-children-list-data">
                    {this.getChildren().map((x, i) => 
                        <div key={i} className="sb-children-list-node">
                            {Render(x)}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
